import React from 'react'
import {StripeBG, Icon} from '../../components'
import {Navbar} from '../../components/marketing'
import {DocToc} from '../../components/blog'

class Overview extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="DocPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <section className="grid-restrain grid-row full-8">
          <DocToc />
          <div className="content markdown-doc grid-item">
            <h1 className="title">Patching Results</h1>
            <div>
              <p>SnapTest allows results to be "patched", which means the ability to re-run only the failed tests in a suite to achieve an overall passing result.
                Patches are important when you're looking for a "green" test run result, but only a few tests fail and you don't want to run the entire suite again.
                They are initiated from the results list:</p>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1555627666/docs/patches/patch1_.5x_2858.png" style={{"max-width": "none"}} /></p>
              <p></p>
              <div className="info">You may run a patch operation on a result as many times as you'd like.</div>
              <div className="warn">Patching is only possible if you've structured your tests not to rely on each-other.</div>
              <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1555627685/docs/patches/patch2_1x_713.png" style={{"max-width": "none"}} /></p>
            </div>
          </div>
        </section>
      </div>
    )
  }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/pages/doc/patchingresults.js